import React from 'react';
import { IPenalty } from '@services/penalty';
import { Link } from 'lucide-react';

const CellInternalFiles = ({
  data,
}: {
  data: IPenalty;
}): JSX.Element | null => {
  if (data.internal_files?.length) {
    return (
      <>
        {data.internal_files.map((file: any) => (
          <div>
            <a key={file.id} href={file.url} target="_blank" rel="noreferrer">
              {file.file_name}
              <Link size={14} />
            </a>
            <br />
          </div>
        ))}
      </>
    );
  }

  return null;
};

export default CellInternalFiles;
